<template>
  <div class="change-head">
    <el-card>
      <div slot="header" class="clearfix">
        <span>{{ $t('menu.xgtx') }}</span>
      </div>
      <div class="pic-main">
        <div class="pic-cut">
          <div v-show="panel" class="container">
            <img class="new-pic" id="image" :style="resetChoose?'':'position:absolute'" :src="url" alt="Picture">
          </div>
        </div>
        <div class="pic-view">
          <span>{{ $t('menu.txyl') }}</span>
          <div class="preview">
            <img :src="headerImage" alt="">
          </div>
          <p>{{ $t('menu.sctx') }}
          <input id="change" type="file" accept="image" @change="change">
          </p>
        </div>
      </div>
      <p class="pic-tips">{{ $t('menu.scxz') }}</p>
      <div class="pic-btns">
        <el-button type="primary" size="mini" @click="commit()">{{ $t('personSkyDri.upload') }}</el-button>
        <el-button @click="cancel()" size="mini">{{ $t('menu.cancel') }}</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import ApiService from '@/services/API-services'
import Cropper from 'cropperjs'
export default {
  name: 'changeHead',
  props: ['modalinfo'],
  data() {
    return {
      user: {},
      imgUrl: '',
      token: '',
      userHead: '',
      headerImage: '',
      picValue: '',
      cropper: '',
      croppable: false,
      panel: true,
      url: '',
      imgCropperData: {
        accept: 'image/bmp, image/jpeg, image/png, image/jpg'
      },
      headPath: '',
      resetChoose: false
    }
  },
  created() {
    this.user = JSON.parse(localStorage.user)
  },
  mounted() {
    this.headerImage = this.user.headImg
    this.url = this.headerImage
    // 初始化这个裁剪框
    this.initCut()
  },
  methods: {
    headUpload(val) {
      const params = new FormData()
      params.append('imgHead', val)
      ApiService.head.HeadUpload(params).then(res => {
        this.headPath = res.path
      })
    },
    // 取消上传
    cancel() {
      this.panel = false
      this.$store.commit('closeModal', 'changeHead')
      // var obj = document.getElementById('change')
      // eslint-disable-next-line no-self-assign
      // obj.outerHTML = obj.outerHTML
    },
    // 创建url路径
    getObjectURL(file) {
      var url = null
      if (window.createObjectURL !== undefined) {
        // basic
        url = window.createObjectURL(file)
      } else if (window.URL !== undefined) {
        // mozilla(firefox)
        url = window.URL.createObjectURL(file)
      } else if (window.webkitURL !== undefined) {
        // webkit or chrome
        url = window.webkitURL.createObjectURL(file)
      }
      return url
    },
    // input框change事件，获取到上传的文件
    change(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      const type = files[0].type // 文件的类型，判断是否是图片
      const size = files[0].size // 文件的大小，判断图片的大小
      if (this.imgCropperData.accept.indexOf(type) === -1) {
        this.$message('请选择支持的图片格式！')
        return false
      }
      if (size > 1048576) {
        this.$message('请选择1M以内的图片')
        return false
      }
      this.resetChoose = true
      this.picValue = files[0]
      e.target.value = ''
      console.log(this.picValue)
      this.url = this.getObjectURL(this.picValue)
      // 每次替换图片要重新得到新的url
      if (this.cropper) {
        this.cropper.replace(this.url)
      }
      this.panel = true
    },
    // 确定提交
    commit() {
      var croppedCanvas
      var roundedCanvas
      var cropBox
      var imgMsg
      if (!this.croppable) {
        return
      }
      // Crop
      croppedCanvas = this.cropper.getCroppedCanvas()
      // Round
      roundedCanvas = this.getRoundedCanvas(croppedCanvas)
      cropBox = this.cropper.getCropBoxData()
      this.headerImage = roundedCanvas.toDataURL('image/png', 1)
      imgMsg = this.cropper.getImageData()
      this.updateHead(this.headerImage)
    },
    // canvas画图
    getRoundedCanvas(sourceCanvas) {
      var canvas = document.createElement('canvas')
      var context = canvas.getContext('2d')
      var width = sourceCanvas.width
      var height = sourceCanvas.height
      canvas.width = width
      canvas.height = height
      context.imageSmoothingEnabled = true
      context.drawImage(sourceCanvas, 0, 0, width, height)
      context.globalCompositeOperation = 'destination-in'
      context.beginPath()
      context.arc(
        width / 2,
        height / 2,
        Math.min(width, height) / 2,
        0,
        2 * Math.PI,
        true
      )
      context.fill()
      return canvas
    },
    updateHead(val) {
      ApiService.head.upSpcHead({
        userId: JSON.parse(localStorage.user).userId,
        account:  JSON.parse(localStorage.user).account,
        headImage: val.substring(val.indexOf(',') + 1)
      }).then(res => {
        if (res.code === 0) {
          this.$message({
            message: '更改成功',
            type: 'success'
          })
          this.initCut()
          this.$store.commit('closeModal', 'changeHead')
          this.getUserInfo(sessionStorage.octopus_token)
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
      })
    },
    getUserInfo(token) {
      ApiService.octopus_user
        .getUserInfo({
          token: token
        })
        .then(res => {
          this.$store.commit('setUserHead', res.data.userEntity.headImg)
          localStorage.user = JSON.stringify(res.data.userEntity)
        })
    },
    initCut() {
      var self = this
      var image = document.getElementById('image')
      this.cropper = new Cropper(image, {
        viewMode: 2,
        preview: '.preview',
        background: false,
        zoomable: false,
        autoCropArea: .5,
        aspectRatio: 1,
        minContainerWidth: 1,
        minContainerHeight: 1,
        minCanvasWidth: 1,
        minCanvasHeight: 1,
        ready: function () {
          self.croppable = true
        }
      })
    }
  }
}
</script>
<style lang="scss">
@import '../../assets/compcss/headImg.scss';
@import '../../common/css/color.scss';
.change-head {
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.2), 0px 6px 16px 0px rgba(0, 0, 0, 0.32), 0px 3px 6px -4px rgba(0, 0, 0, 0.48) !important;
  .pic-main {
    width: 500px;
    display: flex;
    justify-content: space-between;
    .pic-cut {
      display: flex;
      align-items: center;
      .container {
        .new-pic {
          top: -90px;
          bottom: 0;
          right: 175px;
          left: 0;
          margin: auto;
          max-width: 300px;
          max-height: 300px;
        }
      }
    }
    .pic-view {
      display: flex;
      flex-direction: column;
      padding: 20px 0;
      align-items: center;
      .preview {
        img {
          width: 100%;
          height: 100%;
        }
      }
      span {
        color: #999;
        margin-bottom: 10px;
      }
      div {
        width: 120px;
        height: 120px;
        border-radius: 50%;
        overflow: hidden;
        border: 1px solid #ccc;
        margin-bottom: 50px;
      }
      p {
        width: 111px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        color: #fff;
        cursor: pointer;
        background: $card_header;
        position: relative;
        &:hover {
          background: #66b1ff;
        }
        #change {
          width: 111px;
          height: 36px;
          position: absolute;
          opacity: 0;
          top: 0;
          left: 0;
          right: 0;;
          cursor: pointer;
        }
      }
    }
  }
  .pic-tips {
    color: #999;
    font-size: 16px;
    margin-top: 20px;
    text-align: left;
  }
  .pic-btns {
    margin-top: 50px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/user/changeHead.vue